/* eslint-disable @typescript-eslint/camelcase */
import React from 'react'
import { PageWrap } from '../../../layouts'
import { useGetBaoriderTasksQuery, TasksWithCount } from '../../../generated/graphql'
import { MyTasksFilters, MyTasksList, MyTasksMetrics } from '../components'
import { Flex, Spinner } from '@chakra-ui/core'

const MyTask = () => {
  const [filters, setFilters] = React.useState<any>()
  const [start, setStart] = React.useState(0)
  const [limit, setLimit] = React.useState(10)

  const {
    data: myTasks,
    refetch,
    loading
  } = useGetBaoriderTasksQuery({
    fetchPolicy: 'network-only',
    variables: {
      filters,
      pagination: {
        limit
      },
      sort: 'createdAt:desc'
    }
  })
  React.useEffect(() => {
    refetch({
      filters,
      pagination: {
        start,
        limit
      },
      sort: 'createdAt:desc'
    })
  }, [filters, start, limit, refetch])

  const allMyTasks = myTasks?.getBaoriderTasks

  return (
    <PageWrap title="Report Task">
      <MyTasksFilters setFilters={setFilters} />

      <Flex flex={1} justify="space-between" align="center" mb={16}>
        <MyTasksMetrics
          totalNumberOfTasks={allMyTasks?.count || 0}
          filters={filters}
          loading={loading}
        />
      </Flex>

      {loading ? (
        <Flex align="center" justify="center" h="100%">
          <Spinner size="md" color="green.500" speed="0.65s" />
        </Flex>
      ) : (
        <MyTasksList
          tasks={allMyTasks as TasksWithCount}
          pagination={{
            start,
            limit,
            setStart,
            setLimit
          }}
        />
      )}
    </PageWrap>
  )
}

export default MyTask
